import "./App.css";
import "./assets/sass/main.scss";
import Home from "./pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Faq from "./pages/Faq";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Whitelist from "./pages/Whitelist";
import Rewards from "./pages/Rewards";
import Staking from "./pages/Staking";
import BotDetail from "./pages/BotDetail";
import ScrollToTop from "./components/ScrollToTop";

function App() {
	return (
		<BrowserRouter>
			<div className="space"></div>
			<Header />
			<ScrollToTop>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/whitelist" element={<Whitelist />} />
					<Route path="faq" element={<Faq />} />
					<Route path="/rewards" element={<Rewards />} />
					<Route path="/staking" element={<Staking />} />
					<Route path="/nft/:id" element={<BotDetail />} />
				</Routes>
			</ScrollToTop>
			<Footer />
		</BrowserRouter>
	);
}

export default App;
